/** @format */

/**
 * 文字列中の全角数字を半角数字に変換
 *
 * @param {string} fulltext
 * @return {string}
 */
const fullToHalf = (fulltext) => {
  return fulltext.replace(/([０-９])/g, (m, num) => {
    return String(num.charCodeAt() - "０".charCodeAt());
  });
};

const validateBirthday = (y, m, d) => {
  const num = {
    y: Number(y.trim()),
    m: Number(m.trim()),
    d: Number(d.trim()),
  };
  let props = {
    birthYear: y.trim().match(/^\d+$/) ? "" : "年に数値を入力してください",
    birthMonth: m.trim().match(/^\d+$/) ? "" : "月に数値を入力してください",
    birthDay: d.trim().match(/^\d+$/) ? "" : "日に数値を入力してください",
  };

  const birthday = new Date(num.y, num.m - 1, num.d);
  const outputText = `${birthday.getFullYear()}-${
    birthday.getMonth() + 1
  }-${birthday.getDate()}`;
  const inputText = `${num.y}-${num.m}-${num.d}`;

  props[0] = inputText == outputText ? "" : "有効な日付を入力してください";

  return props;
};
export { fullToHalf, validateBirthday };
